import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';

import { SkyModalInstance } from '../../core';


export class SkyWizardDemoFormComponent {
  public title = 'Wizard example';
  public requiredValue1: string;
  public requiredValue2: boolean;

  public get step2Disabled(): boolean {
    return !this.requiredValue1;
  }

  public get step3Disabled(): boolean {
    return this.step2Disabled || !this.requiredValue2;
  }

  constructor(
    public instance: SkyModalInstance
  ) { }

  public validateStep1() {
    return true;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-wizard-form',
  template: `<sky-modal>
  <sky-modal-header>
    {{title}}
  </sky-modal-header>
  <sky-modal-content>
    <sky-tabset tabStyle="wizard" #wizardDemo>
      <sky-tab
        tabHeading="Step 1"
        active="true">
        <label>
          Enter text to continue:
          <input class="sky-form-control" type="text" [(ngModel)]="requiredValue1" />
        </label>
      </sky-tab>
      <sky-tab
        tabHeading="Step 2"
        [disabled]="step2Disabled">
        <sky-checkbox [(ngModel)]="requiredValue2">
          <sky-checkbox-label>
            Select this checkbox to enable step 3.
          </sky-checkbox-label>
        </sky-checkbox>
      </sky-tab>
      <sky-tab
        tabHeading="Step 3"
        [disabled]="step3Disabled">
        Some other content.
      </sky-tab>
    </sky-tabset>
  </sky-modal-content>
  <sky-modal-footer>
    <sky-tabset-nav-button buttonType="previous" [tabset]="wizardDemo"></sky-tabset-nav-button>
    <sky-tabset-nav-button buttonType="next" [tabset]="wizardDemo"></sky-tabset-nav-button>
    <button
      type="button"
      class="sky-btn sky-btn-default"
      (click)="instance.close()">
      Save and close
    </button>
    <button
      type="button"
      class="sky-btn sky-btn-link"
      (click)="instance.cancel()">
      Cancel
    </button>
  </sky-modal-footer>
</sky-modal>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
